import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";

import React from "react";
import { uniqBy } from "lodash/array";
import { API_URL } from "../../../constants/api";
import {
  apiBatchRequest,
  apiPut,
  apiRequest
} from "../../../utils/api_service";
import {
  DISTRIBUTION_GROUP_LIST,
  SECTIONS,
  getRoutingAndNotificationColumn
} from "../../../constants/appConstants";
import AddRoutingAndNotification from "./AddRoutingAndNotification";
import TableWithFilter from "../../common/Table/TableWithFilter";
import { convertIntoDDFormat } from "../../../utils/generic";
import { ShowToast, toastType } from "../../../utils/toast-service";
import { GetEnableProperty, IsSectionVisible } from "../../../utils/helper";

export default class ConfigurationRoutingAndNotification extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataCenterMasterData: [],
      distributionGroupMasterData: [],
      moduleMasterData: [],
      categoryMasterData: [],
      colFilteredObj: [],
      toolTipData: [],
      routingNotificationData: [],
      isOpenPopup: false,
      recipientMasterData: []
    };
  }

  componentDidMount() {
    this.loadData();
  }

  /**
   * return master data from
   */
  loadData = () => {
    apiBatchRequest([
      {
        url: API_URL.user.GetRoutingMaster,
        key: "masterData"
      },
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION },
        key: "toolTipData"
      }
    ]).then(({ masterData, toolTipData }) => {
      const dataCenterMasterData =  GetEnableProperty(uniqBy(
        convertIntoDDFormat(
          masterData.data.filter(x => x.DataKey === "Property") || [],
          "DataValue",
          "DataLabel"
        ),
        x => x.id
      ), SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION, "id");

      
      const categoryMasterData = uniqBy(
        convertIntoDDFormat(
          masterData.data.filter(x => x.DataKey === "Category") || [],
          "DataValue",
          "DataLabel"
        ),
        x => x.value
      );

      const moduleMasterData = uniqBy(
        convertIntoDDFormat(
          masterData.data.filter(x => x.DataKey === "ModuleName") || [],
          "DataValue",
          "DataLabel"
        ),
        x => x.id
      );
      const distributionGroupMasterData = uniqBy(
        convertIntoDDFormat(
          masterData.data.filter(x => x.DataKey === "DistributionGroup") || [],
          "DataValue",
          "DataLabel"
        ),
        x => x.id
      );
      this.setState(
        {
          distributionGroupMasterData: distributionGroupMasterData || [],
          dataCenterMasterData: dataCenterMasterData || [],
          categoryMasterData: categoryMasterData || [],
          recipientMasterData:
            masterData.data.filter(x => x.DataKey === "Recipient") || [],
          moduleMasterData: moduleMasterData || [],
          toolTipData: toolTipData.data || []
        },
        () => {
          this.getRoutingConfigurations();
        }
      );
    });
  };

  /**
   * get routing configuration data
   */
  getRoutingConfigurations = () => {
    apiRequest({ url: API_URL.user.GetRoutingConfigurations }).then(
      ({ data: response }) => {
        this.setState({
          routingNotificationData: response
        });
      }
    );
  };

  /**
   * open update dialog
   * @param {*} isOpen
   * @param {*} usersCount
   */
  openUpdateDialog = (isOpen = true) => {
    this.setState({ isOpenPopup: isOpen });
  };

  /**
   * update distribution group recipient values
   * @param {*} data 
   * @param {*} deleteAll 
   */
  UpdateDistributionGroupRecipient = (data, deleteAll = false) => {
    const params = {
      EmployeeDepartmentId: data.EmployeeDepartmentId,
      PropertyId: data.PropertyId,
      CategoryId: data.CategoryId,
      SectionId: data.SectionId,
      Recipient: deleteAll ? "" : data.Recipient
    };
    apiPut({
      url: API_URL.user.UpdateDistributionGroupRecipient,
      postBody: params
    }).then(({ success: success }) => {
      success != true
        ? ShowToast(
            "Server Error: Unable to delete Request.",
            toastType.ERROR,
            5000,
            500
          )
        : deleteAll === true
        ? ShowToast(
            "Record has been deleted successfully.",
            toastType.SUCCESS,
            5000,
            200
          )
        : ShowToast(
            "Recipient(s) updated successfully.",
            toastType.SUCCESS,
            5000,
            200
          );

      this.getRoutingConfigurations();
    });
  };

  render() {
    const {
      dataCenterMasterData,
      distributionGroupMasterData,
      moduleMasterData,
      categoryMasterData,
      colFilteredObj,
      toolTipData,
      routingNotificationData,
      isOpenPopup,
      routingId,
      recipientMasterData
    } = this.state;
    const optionsListForDataCenter = convertIntoDDFormat(
      dataCenterMasterData || [],
      "value",
      "value"
    );
    const optionsListForDistributionGroup = convertIntoDDFormat(
      distributionGroupMasterData || [],
      "value",
      "value"
    );
    const optionsListForModule = convertIntoDDFormat(
      moduleMasterData || [],
      "value",
      "value"
    );
    const optionsListForCategory = convertIntoDDFormat(
      categoryMasterData || [],
      "value",
      "value"
    );
    let columns = getRoutingAndNotificationColumn(colFilteredObj, {
      dataCenterMasterData: optionsListForDataCenter,
      distributionGroupMasterData: optionsListForDistributionGroup,
      moduleMasterData: optionsListForModule,
      categoryMasterData: optionsListForCategory
    });
    const isVisible = IsSectionVisible(
      SECTIONS.CONFIGURATION,
      SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION,
      SECTIONS.ADD_EDIT
    );
    columns = !isVisible
      ? columns.filter(x => x.colName !== "Action")
      : columns;

    return (
      <>
        {isOpenPopup && (
          <AddRoutingAndNotification
            dataCenterMasterData={dataCenterMasterData}
            distributionGroupMasterData={distributionGroupMasterData}
            moduleMasterData={moduleMasterData}
            categoryMasterData={categoryMasterData}
            isOpen={isOpenPopup || false}
            onClose={this.openUpdateDialog}
            onSave={this.getRoutingConfigurations}
            routingId={routingId}
            toolTipData={toolTipData}
          />
        )}
        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                colSpan={2}
              >
                <div className={"content-header d-flex"}>
                  {" "}
                  <div
                    className={"col-xs-11"}
                    style={{ display: "inline-block", alignItems: "center" }}
                  >
                    {"Routing and Notification Configuration\r"}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <TableWithFilter
                  visibilityAction={{
                    isActionVisible: isVisible
                  }}
                  masterData={{
                    value: recipientMasterData?.filter(x => x.value !== null),
                    selectedIds: "selectedRecipientId",
                    name: "Recipient"
                  }}
                  deleteRecord={this.UpdateDistributionGroupRecipient}
                  tableHeader={DISTRIBUTION_GROUP_LIST}
                  columns={columns}
                  originalData={routingNotificationData}
                  toolTipData={toolTipData}
                  resetPage={this.getRoutingConfigurations}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
